import type { FC, ReactNode } from 'react'

import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area'

import type { ChatAttachment } from './chat-input-attachment.interface'
import { ChatInputFilePreview } from './chat-input-file-preview.atom'

interface ChatInputFileListProps {
  fileList: ChatAttachment[]
  onRemove: (id: string) => void
}

/**
 * Scrollable list of file attachment previews.
 */
export const ChatInputFileList: FC<ChatInputFileListProps> = ({
  fileList,
  onRemove,
}): ReactNode => (
  <div className="chat-input-attachment-files">
    <ScrollArea className="w-full">
      <div className="flex flex-wrap gap-1.5 pb-1">
        {fileList.map((file) => (
          <ChatInputFilePreview key={file.id} attachment={file} onRemove={onRemove} />
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  </div>
)

ChatInputFileList.displayName = 'ChatInputFileList'
